import { getStateColors } from './icon_helpers';

/**
 * Creates a roads - roadways icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createRoadwaysIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- roads - roadways icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="4" y="8" width="16" height="8" rx="1" /><rect fill="${colors.iconColor}" x="11" y="9" width="2" height="1.5" /><rect fill="${colors.iconColor}" x="11" y="11.5" width="2" height="1.5" /><rect fill="${colors.iconColor}" x="11" y="14" width="2" height="1.5" /><rect fill="${colors.iconColor}" x="2" y="10" width="2" height="4" /><rect fill="${colors.iconColor}" x="20" y="10" width="2" height="4" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a roads - speed limits icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createSpeedLimitsIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- roads - speed limits icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="12" cy="10" r="7" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="2" cx="12" cy="10" r="5.5" /><text fill="${colors.iconColor}" x="12" y="13" font-size="6" font-weight="bold" text-anchor="middle">40</text><rect fill="${colors.iconColor}" x="11" y="17" width="2" height="5" /><rect fill="${colors.iconColor}" x="9" y="21.5" width="6" height="1" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a roads - traffic management plans icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createTrafficManagementPlansIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- roads - traffic management plans icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="9" y="3" width="6" height="16" rx="1" /><circle fill="${colors.iconColor}" cx="12" cy="7" r="2" /><circle fill="${colors.iconColor}" cx="12" cy="12" r="2" /><circle fill="${colors.iconColor}" cx="12" cy="17" r="2" /><rect fill="${colors.iconColor}" x="11" y="19" width="2" height="3" /><rect fill="${colors.iconColor}" x="9" y="21.5" width="6" height="1" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const roadsIcons = {
  roadways: createRoadwaysIcon,
  speed_limits: createSpeedLimitsIcon,
  traffic_management_plans: createTrafficManagementPlansIcon
};
